import NoTeacherFound from "assets/NoTeacherFound.png"
import { routesPath } from "conts/routes"
import React from "react"
import { useNavigate } from "react-router-dom"
import styled from "styled-components"
import { ButtonPrimary } from "ui/base/Button/ButtonStyled"
import { convertHexToRGBA, defaultThemeColors } from "ui/theme"

export const TeacherNotFound = () => {
  const navigate = useNavigate()
  return (
    <Container>
      <NoTeacherFoundImageContainer>
        <img
          src={NoTeacherFound}
          alt='NoTeacherFound'
        />
      </NoTeacherFoundImageContainer>
      <NoTeacherText>No instructors found for this class.</NoTeacherText>
      <ButtonPrimary
        variant='primary_fade'
        onClick={() => navigate(routesPath.main)}>
        Return to the Homepage
      </ButtonPrimary>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  height: 83dvh;
`

const NoTeacherText = styled.p`
  margin-bottom: 10px;
`

const NoTeacherFoundImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 282px;
  height: 282px;
  border-radius: 999px;
  background-color: ${convertHexToRGBA(defaultThemeColors.placeholder, 0.2)};
  overflow: hidden;
  margin-bottom: 20px;

  & > img {
    width: 70%;
    height: 70%;
    aspect-ratio: 1/1;
  }
`
